//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-326016 - Remove feature flag after release
export const getIsVibeBrandingSunsetFeatureEnabled = createHasFeatureSelector(
  FeatureNames.VibeBrandingSunset,
);
